export default "__VITE_ASSET__dxvjoS9P__"